import React, { useEffect, useState } from 'react';

interface ChipsItem {
    name: string;
    url: string;
}

interface ChipsProps {
    newProducts: ChipsItem[];
    popularProducts: ChipsItem[];
    relatedCategories: ChipsItem[];
    popularCategories: ChipsItem[];
    relatedProductsFilters: ChipsItem[];
    categoryName: string;
    component: React.FC<{tabs: { title: string; key: string; items: ChipsItem[]; }[]; defaultValue: string; }>;
}

const Chips: React.FC<ChipsProps> = props => {
    const [popularCategories, setPopularCategories] = useState(props.popularCategories);

    useEffect(() => {
        setPopularCategories(popularCategories.sort(() => 0.5 - Math.random()).slice(0, 6));
    }, []);

    const relatedProducts = (): ChipsItem[] => props.relatedProductsFilters.slice(0, 10).map(item => ({
        name: `${props.categoryName} ${item.name}`,
        url: item.url
    }));

    const items = [
        {
            title: 'Popularne Produkty',
            key: 'popular-products',
            items: props.popularProducts
        },
        {
            title: 'Popularne Kategorie',
            key: 'popular-categorys',
            items: popularCategories
        },
        {
            title: 'Nowe Produkty',
            key: 'new-products',
            items: props.newProducts
        },
        {
            title: 'Powiązane Kategorie',
            key: 'related-categories',
            items: props.relatedCategories
        },
        {
            title: 'Powiązane Produkty',
            key: 'related-products',
            items: relatedProducts()
        }
    ];

    return <props.component tabs={items} defaultValue={'popular-products'}/>;
};

export default Chips;
